export interface ServiceLayerAuthConfig {
  /**
   * Public origin of the SPA, e.g. "https://portal.clanda.de" or "http://localhost:5178".
   * If omitted, window.location.origin will be used at runtime.
   */
  siteOrigin?: string;

  /**
   * Base URL for Service Layer from the browser perspective.
   * Examples: "/service" (via reverse proxy) or "https://api.clanda.de".
   */
  serviceLayerBaseUrl: string;

  /**
   * Supabase project URL, e.g. "https://xyzcompany.supabase.co". Optional when Supabase is not used.
   */
  supabaseUrl?: string;

  /**
   * Supabase anon key for browser usage. Optional when Supabase is not used.
   */
  supabaseAnonKey?: string;
}

export function resolveSiteOrigin(config: ServiceLayerAuthConfig): string {
  if (config.siteOrigin) {
    return config.siteOrigin;
  }
  if (typeof window !== "undefined" && window.location?.origin) {
    const origin = window.location.origin;
    // Warn if siteOrigin is not explicitly set (common misconfiguration)
    if (typeof console !== "undefined" && console.warn) {
      console.warn(
        `[ServiceLayerAuth] siteOrigin not configured, using window.location.origin: ${origin}. ` +
        `Set VITE_SITE_ORIGIN=${origin} in your build environment to avoid this warning.`
      );
    }
    return origin;
  }
  throw new Error("siteOrigin is required when window.location is not available");
}

export function resolveApiBase(config: ServiceLayerAuthConfig): string {
  const base = config.serviceLayerBaseUrl || "/service";
  return base.endsWith("/") ? base.slice(0, -1) : base;
}



